<template>
  <NPopper :hover="true" offset-y="5">
    <div
      v-gid="{
        module: 'order',
        screen: 'home',
        section: 'portfolio',
        component: 'SLTPTooltip',
      }"
      class="bg-neutral-quinary rounded-full h-6 w-6 mr-auto flex items-center justify-center"
    >
      <NegarSltpIcon size="16" class="text-neutral-primary" />
    </div>

    <template #content>
      <div class="bg-neutral-quaternary px-2 py-1 rounded-md">
        <div class="grid grid-flow-row grid-cols-1 gap-1">
          <div class="flex justify-between items-center">
            <NText
              class="text-neutral-quaternary self-center"
              variant="caption2"
              weight="regular"
            >
              {{ t('misc.quantity') }}:
            </NText>

            <NText
              class="text-neutral-quaternary self-center"
              variant="caption2"
              weight="medium"
            >
              {{
                t('modules.order.percentOfAsset', {
                  percent: falconInfo.percent,
                })
              }}
            </NText>
          </div>

          <div class="flex justify-between items-center">
            <NText
              class="text-neutral-quaternary self-center"
              variant="caption2"
              weight="regular"
            >
              {{ t('modules.order.profitLimit') }}:
            </NText>

            <div v-if="falconInfo.upperTrigger" class="ms-5">
              <NumberFormatter #="{ number }" :value="falconInfo.upperTrigger">
                <NText
                  class="text-neutral-quaternary self-center"
                  variant="caption2"
                  weight="medium"
                >
                  {{ number }}
                </NText>
              </NumberFormatter>

              <NText variant="overline" class="text-neutral-quaternary ms-1">
                {{ t('misc.rial') }}
              </NText>
            </div>

            <div v-else class="ms-5">
              <NText
                class="text-neutral-quaternary self-center"
                variant="caption2"
                weight="medium"
              >
                -
              </NText>
            </div>
          </div>

          <div class="flex justify-between items-center">
            <NText
              class="text-neutral-quaternary self-center"
              variant="caption2"
              weight="regular"
            >
              {{ t('modules.order.limitOfLoss') }}:
            </NText>

            <div v-if="falconInfo.lowerTrigger" class="ms-5">
              <NumberFormatter #="{ number }" :value="falconInfo.lowerTrigger">
                <NText
                  class="text-neutral-quaternary self-center"
                  variant="caption2"
                  weight="medium"
                >
                  {{ number }}
                </NText>
              </NumberFormatter>

              <NText variant="overline" class="text-neutral-quaternary ms-1">
                {{ t('misc.rial') }}
              </NText>
            </div>

            <div v-else class="ms-5">
              <NText
                class="text-neutral-quaternary self-center"
                variant="caption2"
                weight="medium"
              >
                -
              </NText>
            </div>
          </div>
        </div>
      </div>
    </template>
  </NPopper>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { NText } from '@negar/core';
import { NegarSltpIcon } from '@negar/icons';
import { FalconAlgorithmInfo } from '@libs/api-reference';

import NumberFormatter from '@/components/Number.vue';

type SLTPTooltipProps = {
  falconInfo: FalconAlgorithmInfo;
};

defineProps<SLTPTooltipProps>();

const { t } = useI18n();
</script>
